import { ReconfigureAgentSchedulerFormWebComponent } from './component/ReconfigureAgentSchedulerFormWebComponent';
import { WEB_COMPONENT_RECONFIGURE_AGENT_SCHEDULER_FORM } from '../../../../webcomponents.constants';

export { ReconfigureAgentSchedulerFormWebComponent };

window.customElements.define(WEB_COMPONENT_RECONFIGURE_AGENT_SCHEDULER_FORM, ReconfigureAgentSchedulerFormWebComponent);
